export default __webpack_public_path__ + "static/media/Bracers of the Haunter in the Dark.21ed77e7.jpg";